import * as React from "react";
import { forwardRef } from "react";
const SvgLeftIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M10 5 8 3v1.5H4v1h4V7zM9 8a5 5 0 1 1 0-6H7.635a4 4 0 1 0 0 6z" }));
const ForwardRef = forwardRef(SvgLeftIcon);
export { ForwardRef as ReactComponent };
